import { CharacterCardActions } from "@next-platform/client-common-spicy-ui";
import { AnalyticsEvents } from "@next-platform/client-common-core";

export const CHATBOT_INTERACTION_EVENT_MAP = {
  [CharacterCardActions.INFO]: AnalyticsEvents.CHATBOT_DESCRIPTION,
  [CharacterCardActions.CHAT]: AnalyticsEvents.CHATBOT_SELECT,
  [CharacterCardActions.SHARE]: AnalyticsEvents.CHATBOT_SHARE,
};

export const SOCIAL_MEDIA_EVENT_VALUE = {
  Discord: "discord",
  Reddit: "reddit",
  X: "x",
};
